/**
 * Configuração de filtros do módulo SEO.
 *
 * Subset das métricas do dashboard pago — sem investment/impressions/clicks,
 * já que esses só fazem sentido quando o Google Search Console estiver
 * integrado. Quando isso ocorrer, basta acrescentar entradas aqui (e
 * predicados em `seo.py`) — nenhuma mudança no componente de UI necessária.
 */

export const SEO_METRIC_FILTERS = [
  { key: 'visits',    label: 'Visitantes',         icon: 'users' },
  { key: 'whats',     label: 'Clicks Whats',       icon: 'whats' },
  { key: 'forms',     label: 'Formulários',        icon: 'page' },
  { key: 'contacts',  label: 'Contatos',           icon: 'phone' },
  { key: 'leads',     label: 'Leads',              icon: 'leads' },
  { key: 'qualified', label: 'Leads Qualificados', icon: 'check' },
  { key: 'sales',     label: 'Vendas',             icon: 'sales' },
]

export const SEO_DEFAULT_METRIC = 'leads'

export const SEO_METRIC_LABEL = Object.fromEntries(
  SEO_METRIC_FILTERS.map((m) => [m.key, m.label.toLowerCase()])
)
